import TabPanel from "../TabPanel";
import { SettingsModalTabProps } from "../types";
import { Grid, Tab, Tabs } from "@mui/material";
import UserManagementTab from "../UserManagementTab";
import EquipmentManagementTab from "../EquipmentManagementTab";
import { FC, useContext, useState } from "react";
import { map } from "lodash";
import SubContractorManagementTab from "../SubContractorManagementTab";
import HumanResourcesManagementTab from "../HumanResourcesManagementTab";
import PermissionContext from "@/Contexts/Permissions";
import { PermissionActionEnum, PermissionEntityEnum } from "@/graphql/generated/graphql";

const ResourcesManagementTab: React.FC<SettingsModalTabProps> = ({ parentTab, index, showHeading }) => {
  const [activeTab, setActiveTab] = useState(0);
  const { canPerformAction } = useContext(PermissionContext);
  const { View } = PermissionActionEnum;
  const { EmployeeManagement, EquipmentManagement, SubcontractorManagement } = PermissionEntityEnum;

  const handleMainTabChange = (_: React.SyntheticEvent, newValue: number) => setActiveTab(newValue);
  const buildTabs = (): { [key: string]: FC<SettingsModalTabProps> } => {
    let tabsList = {};

    if (canPerformAction(View, EmployeeManagement)) {
      tabsList = { ...tabsList, "Employees": UserManagementTab }
      tabsList = { ...tabsList, "Human Resources": HumanResourcesManagementTab }
    }

    if (canPerformAction(View, EquipmentManagement)) {
      tabsList = { ...tabsList, "Equipments": EquipmentManagementTab }
    }

    if (canPerformAction(View, SubcontractorManagement)) {
      tabsList = { ...tabsList, "Subcontractors": SubContractorManagementTab }
    }

    return tabsList;
  };

  const availableTabs = buildTabs();

  return (
    <TabPanel value={parentTab} index={index} heading="Resources Management" showHeading={showHeading}>
      <Tabs value={activeTab} onChange={handleMainTabChange}>
        {map(Object.keys(availableTabs), (label, idx) => (
          <Tab key={`resources-tab-label-${idx}`} label={label} />
        ))}
      </Tabs>
      <Grid size={12}>
        {map(Object.values(availableTabs), (TabComponent, idx) => (
          <TabComponent key={`resources-tab-content-${idx}`} parentTab={activeTab} index={idx} />
        ))}
      </Grid>
    </TabPanel>
  );
}

export default ResourcesManagementTab;
